import React, { Fragment, useState } from 'react';

import TemplateSaving from '../../../containers/templates/TemplateSave';
import TemplateEditName from './TemplateEditName';

const TemplateEditing = (props) => {
  const {
    onCreate,
    onUpdate,
    template,
    idUsingTemplate,
    templateName,
    setTemplateName,
    showEdit,
    setShowEdit,
    isCreatingTemplate,
  } = props;

  const [isValid, setValid] = useState(true);

  return (
    <>
      {/* иконка для сохранения темплейта */}
      <TemplateSaving
        template={template}
        idUsingTemplate={idUsingTemplate}
        templateName={templateName}
        onUpdate={() => onUpdate(templateName)}
        onCreate={() => {
          setValid(!!templateName.trim().length);
          return onCreate(templateName);
        }}
      />
      <TemplateEditName
        isValid={isValid}
        setValid={setValid}
        name={templateName}
        setName={setTemplateName}
        setShowEdit={setShowEdit}
        showEdit={showEdit}
        onExec={() => {
          setShowEdit(!showEdit);
          onUpdate(templateName);
        }}
        onCancel={() => {
          setTemplateName(template ? template.name : '');
          setShowEdit(!showEdit);
        }}
        isCloseClick={template !== undefined && template.id === idUsingTemplate}
        showButtons={isCreatingTemplate}
      />
    </>
  );
};

export default TemplateEditing;
